import React, { useCallback } from 'react'

import { hooks } from '@front/volcanion'
import { Loader } from '@front/squirtle'
import Callbacks from './callbacks'

const withContainer = Component => props => {
  const isReady = hooks.useFormStatus('isReady')
  const [, { openDialog }] = hooks.useDialogs()
  const { openNotification } = hooks.useNotification()
  const [{ record_id, user_id, company }] = hooks.useFormState()

  const [sendIndentifier] = hooks.useModelFunction('companyuser', 'sendIdentifier')
  const [identifier, pin] = hooks.useFieldValues(['identifier', 'pin'])

  const onConfirmSendIdentifier = useCallback(Callbacks.handleOnConfirmSendIdentifier(record_id, sendIndentifier, openNotification), [record_id, sendIndentifier, openNotification])
  const openSendIdentifierDialog = useCallback(Callbacks.handleOpenSendIdentifierDialog(openDialog, onConfirmSendIdentifier), [openDialog, onConfirmSendIdentifier])

  const handleClickClientDetail = useCallback(() => {
    !!user_id && window.open(`/client/${user_id}`, '_blank')
  }, [user_id])

  const showIdentifierAction = !!identifier && !!pin

  const mergedProps = {
    handleClickClientDetail,
    openSendIdentifierDialog,
    company,
    showIdentifierAction
  }

  return (
    <Loader isLoading={!isReady}>
      <Component {...mergedProps} {...props} />
    </Loader>
  )
}

export default withContainer
